import React, { useEffect, useState } from "react";
import "./style.css";
import { useParams } from "react-router-dom";
import env from "config";
import SoftButton from "components/SoftButton";
import { useAgencyInfo } from "context/agency";
// import SoftButton from './../../../../../mobile-calendar/src/components/SoftButton/index';

const IframedApp = () => {
    const CUSTOM_URL = env.CUSTOM_URL;
    const { email, locationId } = useParams();
    const [
        agency,
        Update,
        clear,
        agencyConfig,
        UpdateAgencyConfig,
        GHLproducts,
        openSubscriptionModal,
        setOpenSubscriptionModal,
        upgrade,
        setupgrade,
    ] = useAgencyInfo();
    // State to store the iframe URL
    const [iframeUrl, setIframeUrl] = useState("");

    // Function to dynamically update iframe URL
    const handleRoutes = (page) => {
        const newIframeUrl = `${CUSTOM_URL}/${email}/${locationId}/${page}`;
        console.log("newIframeUrlnewIframeUrlnewIframeUrl", newIframeUrl);
        setIframeUrl(newIframeUrl); // Update the iframe URL
    };


    return (
        <>
            <nav className="navbar">
                <div className="navbar-logo">
                    {/* You can place your logo or branding here */}
                    {agency.type == "free_trial" && <SoftButton
                        color={"white"}
                        style={{ color: "black" }}
                        onClick={() => {
                            setOpenSubscriptionModal(true);
                            setupgrade(true);
                        }}
                    >
                        Upgrade
                    </SoftButton>}

                </div>
                <ul className="navbar-links">
                    <li>
                        <span onClick={() => handleRoutes("accounts")}>Accounts</span>
                    </li>
                    <li>
                        <span onClick={() => handleRoutes("users")}>Users</span>
                    </li>
                    <li>
                        <span onClick={() => handleRoutes("library")}>Prompt Library</span>
                    </li>
                    <li>
                        <span onClick={() => handleRoutes("assistants")}>Assistants</span>
                    </li>
                    <li>
                        <span onClick={() => handleRoutes("settings/branding")}>Branding</span>
                    </li>
                    <li>
                        <span onClick={() => handleRoutes("saas")}>SaaS</span>
                    </li>
                    <li>
                        <span onClick={() => handleRoutes("settings/wallet")}>Wallet</span>
                    </li>
                    <li>
                        <span onClick={() => handleRoutes("settings/integration")}>Integration</span>
                    </li>
                </ul>
            </nav>

        </>
    );
};

export default IframedApp;
